import React from "react";
import { Link } from "react-router-dom";

const TeamAreaTwoGrid = () => {
  return (
    <div className="team-area-2 space">
      <div className="container">
        <div className="row gx-30 gy-30">
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-1.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Darrell Steward</Link>
                </h4>
                <span className="team-card_desig">Software Developer</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://facebook.com/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-2.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Robert Fox</Link>
                </h4>
                <span className="team-card_desig">Project Manager</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://facebook.com/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-3.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Ralph Edwards</Link>
                </h4>
                <span className="team-card_desig">Scrum Master</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://facebook.com/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-4.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Wade Warren</Link>
                </h4>
                <span className="team-card_desig">Development Manager</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://facebook.com/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-5.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Kristin Watson</Link>
                </h4>
                <span className="team-card_desig">Ethical Hacker</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://www.facebook.com/800speedy/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="team-card style2">
              <div className="team-card_img">
                <img src="assets/img/team/team-1-6.png" alt="800speedy" />
              </div>
              <div className="team-card_content">
                <h4 className="team-card_title">
                  <Link to="/team-details">Courtney Henry</Link>
                </h4>
                <span className="team-card_desig">Software Developer</span>
                <div className="team-social_wrap">
                  <div className="social-btn style2">
                    <Link to="https://linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://www.instagram.com/">
                      <i className="fab fa-instagram" />
                    </Link>
                    <Link to="https://facebook.com/">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamAreaTwoGrid;
